import MemoDeezer from "../icons/Deezer";
import Spotify from "../icons/Spotify";
import styles from "./export-to-playlist.module.scss";
import qs from "qs";
import { useTranslate } from "app/hooks/lang";
import { BackButtonBar } from "../back-button/back-button.component";
import { useArrowKeyNavigationOverlay } from "app/hooks/keyboard-navigation.hook";
import { useGoBackEvent } from "app/hooks/go-back.hook";
import { useFeaturesContext } from "app/context/features.context";
import { useEffect } from "react";
import QRCode from "react-qr-code";
import { useInterval } from "react-use";
import { useAppSelector } from "app/store/store";
import { selectUserState } from "app/store/slices/user";
import { useAuth } from "app/context/auth.context";
import { useIsLargeDesktopResolution } from "app/utils/is-mobile-resolution";
import { Portal } from "../ui/portal";
import useModalScroll from "app/hooks/modal-scroll.hook";

enum StreamingPlatform {
  SPOTIFY = "SPOTIFY",
  DEEZER = "DEEZER",
}
interface ExportToPlaylistPopupProps {
  onClose: VoidFunction;
}
export const ExportToPlaylistPopup: React.FC<ExportToPlaylistPopupProps> = ({
  onClose,
}) => {
  const t = useTranslate();
  const { showQRCode } = useFeaturesContext();
  const { session } = useAppSelector(selectUserState);
  const largeDesktop = useIsLargeDesktopResolution();
  const { refreshUserData } = useAuth();
  useInterval(() => {
    if (
      session?.user &&
      (!session?.user?.deezer_connect || !session?.user?.spotify_connect)
    ) {
      refreshUserData();
    }
  }, 1000);
  useEffect(() => {
    if (session?.user?.deezer_connect || session?.user?.spotify_connect) {
      onClose();
    }
  }, [session?.user?.spotify_connect, session?.user?.deezer_connect]);
  const loginToSpotify = () => {
    window.location.href =
      "https://accounts.spotify.com/authorize?" +
      qs.stringify({
        response_type: "code",
        client_id: process.env.NEXT_PUBLIC_SPOTIFY_CLIENT_ID,
        scope: `user-read-private user-read-email playlist-read playlist-read-private playlist-modify-public playlist-modify-private`,
        redirect_uri: `${window.location.origin}/spotify/`,
        show_dialog: true,
        // state: ,TODO: Add state to prevent CSRF
      });
  };

  const loginToDeezer = () => {
    window.location.href =
      "https://connect.deezer.com/oauth/auth.php?" +
      qs.stringify({
        app_id: process.env.NEXT_PUBLIC_DEEZER_CLIENT_ID,
        redirect_uri: `${window.location.origin}/deezer`,
        perms: "offline_access,manage_library",
      });
  };
  useGoBackEvent("ExportToPlaylist", onClose);
  const wrapperRef = useArrowKeyNavigationOverlay();

  useModalScroll();

  return (
    <Portal>
      <div className={styles.popup_wrapper} ref={wrapperRef}>
        <div className={styles.content}>
          <BackButtonBar onClick={onClose} />
          {showQRCode ? (
            <div className={styles.qr_instructions_wrapper}>
              <div className={styles.qr_instructions}>
                <h2>{t("playlsit.qr-tutorial.title")}</h2>
                <ul>
                  <li>{t("playlsit.qr-tutorial.step1")}</li>
                  <li>{t("playlsit.qr-tutorial.step2")}</li>
                  <li>{t("playlsit.qr-tutorial.step3")}</li>
                </ul>
              </div>
              <div className={styles.qr_code}>
                <div className={styles.qr_wrapper}>
                  <QRCode
                    value={
                      "https://radioline.co/log-in?redirect=/settings?accountlink=true"
                    }
                    size={largeDesktop ? 360 : 261}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.platform_selector}>
              <h2 className={styles.header}>{t("export.select-platform")}</h2>
              {/* <div className={styles.platform}>
            <button>
              <MemoAppleMusic />
            </button>
          </div>
           */}
              <div className={styles.platform} data-navigate-row>
                <button
                  data-navigate-item
                  onClick={() => {
                    loginToDeezer();
                  }}
                >
                  <MemoDeezer />
                </button>
              </div>
              <div className={styles.platform} data-navigate-row>
                <button
                  data-navigate-item
                  onClick={() => {
                    loginToSpotify();
                  }}
                >
                  <Spotify />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Portal>
  );
};
